/**
 * Work order scheduled (plan) date rules — keep in sync with
 * prod/services/workOrderScheduledDatePolicy.js
 */
import { ROLES } from '../constants/roles';

const CAMO_TEAM_SCHEDULE_DATE_ROLES = [
  ROLES.CA_MANAGER,
  ROLES.CA_TECHNICAL_OFFICER,
  ROLES.CAMO_QM_MANAGER,
  ROLES.CAMO_QM_OFFICER,
  ROLES.PLANNING_MANAGER
];

export const isWorkOrderWithCamoTeam = (m) => {
  if (!m) return false;
  if (m.planningApproved) return false;
  if (!m.camoQmAcknowledged) return true;
  if (m.planningRejectedAt) return true;
  return false;
};

export const isWorkOrderInPlanningQueue = (m) => {
  if (!m) return false;
  if (!m.camoQmAcknowledged || m.planningApproved) return false;
  if (m.planningRejectedAt) return false;
  return true;
};

export const isPlanningReworkAfterStoreOrMroReject = (m) => {
  if (!m || !m.planningApproved) return false;
  const storeRework = m.needsStoreAction && m.storeRejectedAt && !m.storeAccepted;
  const mroRework = m.needsMROAction && m.mroRejectedAt && !m.mroAccepted;
  return Boolean(storeRework || mroRework);
};

export const isBeforeMroHandover = (m) => {
  if (!m) return false;
  return !m.mroAccepted && !m.mroAssignedEngineerId && !m.mroEngineerCompleted;
};

export const canUserChangeWorkOrderScheduledDate = (maintenance, userRole) => {
  if (!maintenance || !userRole) return false;
  if (maintenance.status === 'CANCELLED' || maintenance.status === 'COMPLETED') return false;
  if (userRole === ROLES.SUPER_ADMIN || userRole === ROLES.ACCOUNTABLE_MANAGER || userRole === ROLES.AM_MRO) return true;
  if (userRole === ROLES.PLANNING_MANAGER) {
    return isBeforeMroHandover(maintenance);
  }
  if (CAMO_TEAM_SCHEDULE_DATE_ROLES.includes(userRole)) {
    return isWorkOrderWithCamoTeam(maintenance);
  }
  return false;
};
